<template>
  <div>
    <Loading :loading="!events" />
    <div v-if="events">
      <div class="md-layout">
        <div class="md-layout-item">
          <h2>Historico</h2>
        </div>
        <div class="md-layout-item" style="text-align: right">
          <md-button @click="$emit('close')">
            <md-icon>close</md-icon>
          </md-button>
        </div>
      </div>
      <md-table>
        <md-table-row>
          <md-table-head>Acao</md-table-head>
          <md-table-head>Status</md-table-head>
          <md-table-head>Horário</md-table-head>
        </md-table-row>

        <md-table-row v-for="event in events" :key="event.id">
          <md-table-cell>
            {{ event.title }}
          </md-table-cell>
          <md-table-cell>
            <show-acao-status :value="event.data.status" />
          </md-table-cell>
          <md-table-cell>
            {{ formatDate(event.criadoEm) }}
          </md-table-cell>
        </md-table-row>
      </md-table>
    </div>
  </div>
</template>

<script>
import { validationMixin } from 'vuelidate'

import ShowAcaoStatus from '@/components/ShowAcaoStatus.vue'
import { formatDate } from '@/utils/transform'

import Loading from '../../components/Loading'
import http from '../../utils/http'

export default {
  name: 'EquipamentoHistoricoAcao',
  components: { ShowAcaoStatus, Loading },
  mixins: [validationMixin],
  props: {
    equipamentoId: {
      type: String,
      required: true,
    },
    acaoId: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      events: null,
    }
  },
  mounted() {
    this.loadEventos()
  },
  methods: {
    async loadEventos() {
      this.events = (
        await http.get(
          `equipamento/${this.equipamentoId}/acao/${this.acaoId}/historico`
        )
      ).events
    },
    formatDate,
  },
}
</script>

<style lang="scss" scoped>
.left-zero {
  padding-left: 0;
  margin-left: 0;
  margin-right: 5% !important;
}
</style>
